
import Vue, { PropType } from 'vue';
import { Location } from 'vue-router';
import PulsatingDot from '~/components/miscellaneous/PulsatingDot.vue';

export default Vue.extend({
    name: 'NavLink',
    components: { PulsatingDot },
    props: {
        label: {
            type: String,
            default: '',
        },
        image: {
            type: String,
            default: '',
        },
        to: {
            type: [String, Object] as PropType<string | Location>,
            required: true,
        },
        activeClass: {
            type: String,
            default: 'active',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        exact: {
            type: Boolean,
            default: false,
        },
        external: {
            type: Boolean,
            default: false,
        },
        newTab: {
            type: Boolean,
            default: true,
        },
        isNew: {
            type: Boolean,
            default: false,
        },
        newBadge: {
            type: Boolean,
            default: false,
        },
        matches: {
            type: Array as () => string[],
            default: () => [],
        },
    },
    computed: {
        isMatch(): boolean {
            return this.matches.find(m => this.$route.path.startsWith(m)) !== undefined;
        },
    },
});
